import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../assets/css/Care-Registration.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import {
    hand,
    senior,
    service1,
    service2,
    service3,
    service4,
    service5,
    service6,
} from "../../Constant";
import { AddServicesAction } from "../../redux/actions/auth";
import useQuery from "../../useQuery";

const CareRegistration = ({ auth, services, addServices }) => {
    const navigate = useNavigate();

    const [oldServiceIds, setOldServiceIds] = useState([]);
    const [serviceIds, setServiceIds] = useState([]);
    const query = useQuery();

    useEffect(() => {
        let newServiceIds = auth.user.services.map((singleService) =>
            parseInt(singleService.service_id)
        );
        console.log(newServiceIds);
        setOldServiceIds(newServiceIds);
        setServiceIds(newServiceIds);
        if (!query.get("back")) {
            if (auth.user.services?.length > 0) {
                // if (auth.user.services[0].per_hour == null) {
                navigate("/care-giver-registration-2?back=true");
                // } else {
                //     navigate("/care-giver-registration-3?back=true");
                // }
            }
        }
    }, [auth]);

    const submit = async () => {
        addServices(
            serviceIds,
            !(JSON.stringify(oldServiceIds) == JSON.stringify(serviceIds))
        ).then(() => {
            // console.log(auth);
            if (auth.user.services?.length > 0) {
                navigate("/care-giver-registration-2?back=true");
            }
        });
    };

    return (
        <>
            <Header />
            {/* <!-- Care Giver Registration Form --> */}
            <div className="care-registration">
                <div className="container">
                    <div className="top_bar">
                        <div className="heading_wrapper">
                            <h2>Care Giver Registration</h2>
                            <p>
                                You can register and connect with a specialist
                                caregiver or home-helper by following our 5-step
                                easy process.
                            </p>
                        </div>
                        <div className="tab_nav" role="tablist">
                            <span className="borderTop"></span>
                            <ul
                                className="navs nav-tabs"
                                id="myTab"
                                role="tablist"
                            >
                                <li className="nav-item active">
                                    <span className="count">1</span>
                                    <h6>Service Selection</h6>
                                </li>

                                <li className="nav-item">
                                    <span className="count">2</span>
                                    <h6>Service Setup</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">3</span>
                                    <h6>Build Trust</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">4</span>
                                    <h6>Finalization</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">5</span>
                                    <h6>Payment</h6>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div id="wizard">
                        <h6>First</h6>
                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#" style={{color:'#000'}}>Terms of Service</a>
                                </p>
                            </div>
                            <div className="button-group">
                                <button
                                    onClick={() => navigate("/")}
                                    className="btn"
                                >
                                    Cancel
                                </button>
                                <button className="btn ml-2" onClick={submit}>
                                    Save &amp; Continue
                                </button>
                            </div>
                        </div>
                        <section id="tabcontent" className="first_tab">
                            <div className="head_wrapper">
                                <h5>Services Selection</h5>
                                <p>
                                    Select Services you want to provide .You can
                                    select multiple service
                                </p>
                            </div>
                            <div className="row">
                                {services.map((service) => {
                                    return (
                                        <div
                                            className="col-md-2"
                                            key={service.id.toString()}
                                        >
                                            <label className="radioss">
                                                <input
                                                    type="checkbox"
                                                    checked={serviceIds.includes(
                                                        service.id
                                                    )}
                                                    name="service_ids[]"
                                                    onChange={() => {
                                                        if (
                                                            serviceIds.includes(
                                                                service.id
                                                            )
                                                        ) {
                                                            let serviceIdss =
                                                                serviceIds.filter(
                                                                    (
                                                                        serviceId
                                                                    ) =>
                                                                        serviceId !=
                                                                        service.id
                                                                );
                                                            setServiceIds(
                                                                serviceIdss
                                                            );
                                                        } else {
                                                            let serviceIdss = [
                                                                ...serviceIds,
                                                            ];
                                                            serviceIdss.push(
                                                                service.id
                                                            );
                                                            setServiceIds(
                                                                serviceIdss
                                                            );
                                                        }
                                                    }}
                                                />
                                                <span className="checkmark">
                                                    <div className="service_box">
                                                        <div className="img_box">
                                                            <figure>
                                                                <img
                                                                    src={
                                                                        config.assetUrl +
                                                                        "/uploads/" +
                                                                        service.image
                                                                    }
                                                                    alt=""
                                                                />
                                                            </figure>
                                                        </div>
                                                        <div className="txtDv">
                                                            <h5 className="child-care-service">
                                                                {service.title}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </span>
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </section>

                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#" style={{color : '#000'}}>Terms of Service</a>
                                </p>
                            </div>
                            <div className="button-group">
                                <button
                                    onClick={() => navigate("/")}
                                    className="btn"
                                >
                                    Cancel
                                </button>
                                <button className="btn ml-2" onClick={submit}>
                                    Save &amp; Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Care Giver Registration Form --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    services: state.services,
});

const mapDispatchToProps = (dispatch) => ({
    addServices: async (service_ids, sparse) =>
        dispatch(await AddServicesAction(service_ids, sparse)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CareRegistration);
